export const monthlyPayment = (principal, aprPct, years) => {
  if (principal <= 0 || years <= 0) return 0;
  const r = aprPct / 100 / 12;
  const n = years * 12;
  if (r === 0) return principal / n;
  return (principal * r * (1 + r) ** n) / ((1 + r) ** n - 1);
};

// Payment per bank at the chosen term, capped at that bank's max term
export const bankRowsAtTerm = (rows, financed, termYears) =>
  (rows || []).map((row) => {
    const years = Math.min(termYears, row.term_years);
    return {
      ...row,
      chosen_years: years,
      capped: termYears > row.term_years,
      chosen_monthly: monthlyPayment(financed, row.rate, years),
    };
  });
